import React from 'react'
export function FilterDropdownItem({ optionCount, onChange, checked }) {
  return (
    <div
      className='mtt-filter__dropdown-item'
      onClick={(e) => {
        e.stopPropagation()
      }}
    >
      <label>
        <input type='checkbox' onChange={onChange} checked={checked} />
        <span>
          <div className='mtt-filter__dropdown-item-name' dangerouslySetInnerHTML={{ __html: optionCount.name }} />
          <div className='mtt-filter__dropdown-item-qty'> ({optionCount.count}) </div>
        </span>
      </label>
    </div>
  )
}
